/**
 * Module dependencies.
 */

import React from 'react';
import { cn } from 'app/lib/utils';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  children?: React.ReactNode;
};

/**
 * Export `SubTitle` component.
 */

export function SubTitle({ children, className }: Props): JSX.Element {
  return <span className={cn('block pb-4 text-[15px] font-light text-muted-foreground', className)}>{children}</span>;
}
